import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DepthLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "square", d: "M14.342 4.332h7.348M14.374 8.262h5.24M14.342 11.968h7.348M14.374 15.802h5.24M6.61 2.32V22M3 5.674 6.578 2l3.578 3.674M10.156 18.326 6.578 22 3 18.326M14.342 19.764h7.348" }) }) });
}
const DepthLightCustom = forwardRef(_DepthLightCustom);
export { DepthLightCustom };
